import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  sanitaryInput: {
    width: '100%'
  },

  sanitaryDivider: {
    margin: '16px 0'
  },

  sanitaryTitle: {
    marginBottom: 24
  },

  sanitarySelectInput: {
    borderRadius: 4,
    marginBottom: 16,
    '& .MuiSelect-multiple': {
      fontFamily: theme.app.typography.fontFamily.main,
      fontSize: theme.app.typography.paragraph.fontSize,
      backgroundColor: theme.app.colors.input.background,
      border: `1px solid ${theme.app.colors.input.background}`,
      color: '#000',
      height: 18,
      '&:focus': {
        outline: 'none'
      },
      '&:disabled': {
        opacity: 0.5
      },
      '&:hover': {
        color: theme.app.colors.text.primary,
        backgroundColor: theme.palette.secondary.main
      }
    }
  },

  sanitaryMenuItem: {
    '& .css-12wnr2w-MuiButtonBase-root-MuiCheckbox-root.Mui-checked': {
      color: theme.palette.primary.main
    },
    '& .css-12wnr2w-MuiButtonBase-root-MuiCheckbox-root.MuiCheckbox-indeterminate': {
      color: theme.palette.primary.main
    },
    '& .css-kk1bwy-MuiButtonBase-root-MuiMenuItem-root.Mui-selected:hover': {
      backgroundColor: theme.palette.primary.main
    }
  }
}))
